// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3w5t1","icon":"style_icon__3J02-","avatar":"style_avatar__2-bAX","menuIcon":"style_menuIcon__32-77"};